import { defineStore } from 'pinia';

export const useGoodPostageStore = defineStore('goodPostage', {
  state: () => ({
    country: '',
    state: ''
  }),
  actions: {
    setCountry(country: string) {
      this.country = country;
    },
    setState(state: string) {
      this.state = state;
    }
  },
  persist: {
    enabled: true,
    strategies: [
      // { storage: sessionStorage, paths: ['firstName', 'lastName'] },
      { key: 'goodPostage' }
    ]
  }
})
